import { jsx as _jsx, jsxs as _jsxs } from "preact/jsx-runtime";
import { NumberInput } from '@/components';
export function PhonePropertiesSection({ register, errors }) {
    return (_jsxs("div", { className: "space-y-6 pt-4 border-t border-slate-200 dark:border-slate-600 md:border-0 md:pt-0", children: [_jsx("h3", { className: "text-lg font-medium text-slate-900 dark:text-white", children: "Phone Properties" }), _jsx(NumberInput, { label: "Number of Dials", required: true, min: 1, placeholder: "1", error: errors.NumberOfDials?.message, ...register('NumberOfDials', {
                    required: 'Number of dials is required',
                    valueAsNumber: true,
                    min: { value: 1, message: 'Number of dials must be at least 1' }
                }) })] }));
}
